/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_UnauthorizedInputs */

const es_co2_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo o contraseña incorrectos.`)
};

/**

* @param {Error_UnauthorizedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_unauthorized = /** @type {((inputs?: Error_UnauthorizedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_UnauthorizedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_unauthorized(inputs)
});